import { createFileRoute } from '@tanstack/react-router';
import { Hero } from '../components/sections/hero';
import { Problem } from '../components/sections/problem';
import { HowItWorks } from '../components/sections/how-it-works';
import { Features } from '../components/sections/features';
import { Stats } from '../components/sections/stats';
import { Pricing } from '../components/sections/pricing';
import { Trust } from '../components/sections/trust';
import { Faq } from '../components/sections/faq';
import { FinalCta } from '../components/sections/cta';

export const Route = createFileRoute('/')({
  component: LandingPage,
});

function LandingPage() {
  return (
    <>
      <Hero />
      <Problem />
      <HowItWorks />
      <Features />
      <Stats />
      <Pricing />
      <Trust />
      <Faq />
      <FinalCta />
    </>
  );
}
